"use client";

import Image from "next/image";
import type { ComponentProps } from "react";
import { useState } from "react";

// next/image that falls back to a predefined photo when the source fails to
// load (or is empty) — e.g. an admin upload that only exists on the production
// disk when viewed from a local dev server sharing the same database.
type Props = Omit<ComponentProps<typeof Image>, "src"> & {
  src: string;
  fallback: string;
};

export function SafeImage({ src, fallback, alt = "", ...rest }: Props) {
  const [current, setCurrent] = useState(src || fallback);
  // Reset when the incoming src changes (e.g. the lightbox switches photos).
  const [prevSrc, setPrevSrc] = useState(src);
  if (src !== prevSrc) {
    setPrevSrc(src);
    setCurrent(src || fallback);
  }

  return (
    <Image
      {...rest}
      alt={alt}
      src={current}
      onError={() => setCurrent((c) => (c === fallback ? c : fallback))}
    />
  );
}
